// removed by extract-text-webpack-plugin
module.exports = {"Button__small___1JjIL":"Button__small___1JjIL","Button__medium___2PQuO":"Button__medium___2PQuO","Button__large___eBhCW":"Button__large___eBhCW","Button__button___183vh":"Button__button___183vh","Button__isDangerousAction___3jNzY":"Button__isDangerousAction___3jNzY"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Button/buyer/Secondary.css
// module id = ./node_modules/dibs-elements/dist/Button/buyer/Secondary.css
// module chunks = 4